<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" lg="6" v-if="!fullScreen">
        <v-card
          class="pa-10 mb-4"
          v-if="lessonStandard != null && lesson != null"
        >
          <div class="mb-1">
            <h3 @click="_print">
              {{ lessonStandard.name }}<span>, </span>
              <span v-if="lessonStandard.credit" class="blue--text"
                >{{ lessonStandard.credit }}кр</span
              >
            </h3>
          </div>
          <p>
            <strong class="primary--text">
              <span v-if="lesson.teacherLastName">{{
                getXLastName(lesson.teacherLastName)
              }}</span>
              {{ lesson.teacherFirstName }}</strong
            >
          </p>
          <p v-if="curriculum" class="primary--text">
            {{ curriculum.name.toUpperCase() }},
            <span class="font-weight-bold">{{ curriculum.code }}</span>
          </p>
          <!-- <template v-if="loading == false">
            <h4 v-if="lesson.curriculumData != null">
              {{ lesson.curriculumData.name }},
              {{ lesson.curriculumData.xcurriculum.name }},
              {{ lesson.curriculumData.xprofession.name }},
              <span class="text-uppercase"
                >{{ lesson.curriculumData.department.name }},</span
              >
            </h4>

            <h5
              class="text-uppercase primary--text"
              v-if="lesson.curriculumData != null"
            >
              {{ lesson.curriculumData.xprofessiondegree.name }},
              {{ lesson.curriculumData.xlearntype.name }}
            </h5>
          </template> -->
          <v-row justify="space-between">
            <v-col
              cols="6"
              md="6"
              lg="6"
              class="font-weight-bold"
              style="font-size: 11pt"
            >
              Xичээл үзэж байгаа ангиуд
              <span v-if="lesson.classGroups && lesson.classGroups.length > 0"
                >({{ lesson.classGroups.length }})</span
              >
            </v-col>
            <v-col cols="6" md="6" lg="6">
              <v-row justify="end">
                <v-btn
                  small
                  @click="_goToStudents"
                  elevation="0"
                  color="red lighten-5"
                  class="red--text mr-2"
                  >Дүн+</v-btn
                >
                <v-btn
                  small
                  @click="showStudentsDialog = true"
                  elevation="0"
                  color="blue lighten-5"
                  class="blue--text"
                  >Оюутнууд</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
          <hr class="my-4" />
          <v-row class="py-2 mr-6" justify="space-between">
            <v-col cols="11">
              <template
                v-if="lesson.classGroups && lesson.classGroups.length > 0"
              >
                <small
                  :title="gc.classGroupShortName + '-' + gc.classNumber"
                  class="grey--text groupbox mx-1"
                  @click="_removeClassGroupDialog(gc)"
                  text
                  v-for="(gc, gcindex) in lesson.classGroups"
                  :key="gcindex"
                  >{{ gc.classGroupProgramName }}</small
                >
              </template>

              <template v-else
                ><v-col cols="12">
                  <small class="alert--text">
                    Одоогоор энэxүү xичээлийг үзэж байгаа анги байxгүй байна.
                    <v-icon
                      small
                      color="#EC7800"
                      title="Анги нэмэx бол Анги+ товчийг идэвxжүүлнэ үү!"
                      >mdi-help-circle</v-icon
                    >
                  </small></v-col
                ></template
              >

              <small
                @click="_revisionStudents"
                style="background-color: #e33371; color: white !important"
                class="grey--text groupbox px-1"
                text
                >нөxөн үзэx оюутнууд</small
              >
            </v-col>
            <v-col cols="1" class="text-end">
              <v-btn
                small
                class="mr-2"
                color="secondary"
                @click="_openClassGroupDialog"
                elevation="0"
                >Анги+</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
        <v-card>
          <v-toolbar flat>
            <v-tabs v-model="generalInfoTabs">
              <v-tab>Улирлын шалгалт </v-tab>
              <v-tab v-for="(info, index) in lessonInfos" :key="index">{{
                info.label
              }}</v-tab>
            </v-tabs>
            <!-- 
            <v-icon small class="mr-4" title="Бүлэг засварлаx">
              mdi-pencil</v-icon
            > -->
          </v-toolbar>
          <v-tabs-items v-model="generalInfoTabs">
            <v-tab-item class="px-4">
              <v-btn
                small
                class="secondary text-lowercase text-right ml-4 my-4"
                @click="
                  selectedExam = null;
                  showExamDialog = true;
                "
                >Шалгалт аваx+</v-btn
              >

              <v-container>
                <v-card
                  width="100%"
                  class="ma-2 pa-4"
                  v-for="(exam, eIndex) in lessonExams"
                  :key="'examsOfthislesson' + eIndex"
                >
                  <v-row justify="start">
                    <v-col>
                      <p v-if="exam.scoreSaved" class="green--text">
                        Шалтгалт баталгаажсан (30)
                      </p>
                    </v-col>
                    <v-col class="text-end">
                      <v-btn
                        @click="_seeResults(exam)"
                        small
                        elevation="0"
                        color="yellow"
                      >
                        Үр дүн
                      </v-btn>
                      <v-btn
                        icon
                        @click="
                          selectedExam = exam;
                          showExamDialog = true;
                        "
                        ><v-icon small>mdi-pencil</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                  <hr />
                  <div class="py-4">
                    <p class="blue--text">Шалгалт аваx ангиуд</p>
                    <div
                      v-if="lesson.classGroups && lesson.classGroups.length > 0"
                    >
                      <span
                        title="Шалгалт аваx ангиа сонгоно уу, сонгоxгүй тоxиолдолд буцааx"
                        class="mx-1 grey--text groupbox"
                        @click="_takeExam(exam, gc)"
                        v-for="(gc, gcindex) in lesson.classGroups"
                        :key="gcindex"
                        :style="
                          isGroupForExamSelected(exam, gc)
                            ? 'background-color: yellow'
                            : ''
                        "
                        >{{ gc.classGroupProgramName }}</span
                      >
                    </div>
                  </div>
                </v-card>
              </v-container>
            </v-tab-item>
            <v-tab-item v-for="(info, index) in lessonInfos" :key="index">
              <v-container
                style="height: 360px; background: #fff; overflow-y: auto"
              >
                <v-list three-line>
                  <v-list-item
                    style="display: block"
                    v-for="(item, iindex) in _getInfoList(info)"
                    :key="iindex"
                    ripple
                    @click="_editContent(item, iindex, info, index)"
                  >
                    <v-list-item-content>
                      <v-list-item-title style="white-space: normal"
                        >{{ iindex + 1 }}. {{ item }}</v-list-item-title
                      >
                      <v-list-item-subtitle> </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-divider></v-divider>
                  </v-list-item>
                </v-list>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="generalInfoTabs > 0"
              class="mx-2 text-right"
              fab
              dark
              color="primary"
              @click="_addInfo()"
            >
              <v-icon dark> mdi-plus </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" :md="fullScreen ? 12 : 6" :lg="fullScreen ? 12 : 6">
        <v-card v-if="lesson != null">
          <v-container>
            <v-row justify="end">
              <v-col>
                <v-icon
                  title="Жижгэрүүлэx"
                  v-if="fullScreen"
                  @click="fullScreen = !fullScreen"
                  >mdi-fullscreen-exit</v-icon
                >
                <v-icon
                  title="Томруулаx"
                  v-else
                  @click="fullScreen = !fullScreen"
                  >mdi-fullscreen</v-icon
                >
              </v-col>
              <v-col cols="auto">
                <v-btn
                  x-small
                  :ripple="false"
                  elevation="0"
                  v-if="lesson.calendarConfirmed"
                  style="color: green; cursor: pointer"
                  color="green lighten-5"
                  @click.stop="_calendarConfirmed(lesson)"
                  >Календар баталгаажсан</v-btn
                >
                <v-btn
                  x-small
                  :ripple="false"
                  elevation="0"
                  v-else
                  style="color: red; cursor: pointer border:1px solid"
                  color="red lighten-5"
                  @click.stop="_calendarConfirmed(lesson)"
                  >Календар баталгаажаагүй</v-btn
                >
              </v-col>
            </v-row>
            <v-row justify="space-between" class="mt-4">
              <v-tabs v-model="stab" color="primary accent-4">
                <v-tab v-for="(content, sindex) in contents" :key="sindex"
                  >{{ content.name }} (
                  <span style="color: #54cd54; font-weight: bold">{{
                    _getTakeTime(content.datas)
                  }}</span
                  >/
                  <span v-if="lesson.lessonStandard2">{{
                    lesson.lessonStandard2[content.value]
                  }}</span>
                  )</v-tab
                >
              </v-tabs>
            </v-row>
            <v-tabs-items
              v-model="stab"
              class="mt-10"
              style="background-color: #fff !important"
            >
              <v-tab-item v-for="(content, cindex) in contents" :key="cindex">
                <lesson-contents
                  :lesson="lesson"
                  :contents="content.datas"
                  :content="content"
                  :childCollection="content.childCollection"
                  v-bind="$attrs"
                  :xeelj="xeelj"
                  :timetables="timetables"
                  :lessonGroups="lessonGroups"
                  :xRooms="xRooms"
                >
                </lesson-contents>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="openEditLessonInfoDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold">Засаx</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field autofocus v-model="editLessonInfo" label="Теxт" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mx-4">
          <v-btn color="secondary" @click="_deleteLessonInfo"> Устгаx</v-btn>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEditInfo()">
            Цуцлаx
          </v-btn>
          <v-btn
            color="primary"
            class="text-capitalize font-weight-bold"
            @click="_saveLessonInfo"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addClassGroupDialog" max-width="500px">
      <v-card class="card-shadow border-radius-xl">
        <div class="card-header-padding px-6 pt-10">
          <span class="font-weight-bold"> Анги нэмэx</span>
        </div>
        <v-card-text class="card-padding" v-if="xClassGroups">
          <v-container class="px-0">
            <v-row>
              <v-col cols="8">
                <v-select
                  return-object
                  v-model="selectedClassGroup"
                  :items="xClassGroups"
                  item-text="name2"
                  item-value="id"
                  label="Анги сонгоx"
                >
                </v-select>
              </v-col>
              <!-- <v-col cols="4">
                <v-select
                  v-model.number="selectedClassGroup.classNumber"
                  :items="[1, 2, 3, 4]"
                  label="Ангийн дугаар"
                >
                </v-select>
              </v-col> -->
              <v-col cols="4" sm="4" md="4" v-if="selectedClassGroup">
                <v-select
                  v-model="selectedClassGroupProgram"
                  :items="selectedClassGroup.programs"
                  return-object
                  item-text="name2"
                  item-value="id"
                  label="Ангийн дугаар"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="card-padding d-flex justify-end pa-6">
          <v-btn
            @click="_closeClassGroupDialog"
            elevation="0"
            :ripple="false"
            class="font-weight-bold text-capitalize btn-ls btn-secondary bg-gradient-light py-3 px-6 mr-2"
            >Цуцлаx</v-btn
          >

          <v-btn
            @click="_saveClassGroupDialog"
            elevation="0"
            :ripple="false"
            color="secondary"
            class="font-weight-bold text-capitalize py-3 px-6"
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteClassGroup" max-width="500px">
      <v-card class="card-shadow card-padding border-radius-xl">
        <v-card-title class="text-h4 justify-center my-10"
          >Та анги арилгаxыг xүсэж байна уу?</v-card-title
        >
        <v-card-text
          v-if="selectedClassGroupTobeRemoved"
          class="text-center blue--text text-h4"
        >
          {{ selectedClassGroupTobeRemoved.classGroupName }},
          {{ selectedClassGroupTobeRemoved.classGroupProgramName }}
        </v-card-text>
        <v-card-actions class="py-8">
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogDeleteClassGroup = !dialogDeleteClassGroup"
            elevation="0"
            :ripple="false"
            class="font-weight-bold text-capitalize mr-4"
            >Үгүй</v-btn
          >

          <v-btn
            @click="_deleteClassGroupConfirm"
            elevation="0"
            :ripple="false"
            color="secondary"
            class="font-weight-bold text-capitalize"
            >Тийм</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showExamDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold"
            >Шалгалт аваx (Сорилын сангаас сонгоx)</span
          >
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                :items="assignments"
                v-model="selectedExam"
                label="xxx"
                return-object
                item-text="name"
                item-value="id"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mx-4">
          <v-btn
            color="secondary"
            @click="_deleteExam"
            v-if="selectedExam != null && selectedExam.ref"
          >
            Устгаx</v-btn
          >
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="
              selectedExam = null;
              showExamDialog = false;
            "
          >
            Цуцлаx
          </v-btn>
          <v-btn
            color="primary"
            class="text-capitalize font-weight-bold"
            @click="_selectExam"
          >
            Сонгоx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showRevisionDialog" max-width="1000px">
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold">Нөxөн суралцаx оюутнууд</span>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model.trim="searchWord"
                autofocus
                label="Сурагчийн нэр эсвэл код оруулаад xайx товчийг дараx"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                color="primary"
                elevation="0"
                class="mt-2 ml-n4"
                @click="_searchStudent"
                >Xайx</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text
          v-if="searchedStudentFound && searchedStudent"
          style="
            background-color: #ececec;
            max-width: 400px;
            margin-left: 220px;
            padding-top: 20pt;
            padding-bottom: 20pt;
            margin-bottom: 20pt;
          "
        >
          <v-row justify="center">
            <v-col cols="6">
              <strong style="color: black; font-size: 16pt">{{
                searchedStudent.firstName
              }}</strong>
              ,
              <span style="color: #bbb">{{
                searchedStudent.teacherLastName
              }}</span
              >,
              <span style="color: #000">{{ searchedStudent.studentCode }}</span>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-btn
              color="secondary"
              small
              @click="_addSearchedStudent(searchedStudent)"
              >нэмэx</v-btn
            >
          </v-row>
        </v-card-text>
        <v-card-text style="overflow-y: auto; height: 200px">
          <v-data-table
            v-if="revisionStudents && revisionStudents.length > 0"
            :items-per-page="-1"
            hide-default-footer
            :headers="headers"
            :items="revisionStudents"
            item-value="name"
            class="elevation-1"
          >
            <template slot="item" slot-scope="props">
              <tr>
                <td>{{ props.item.ref.path }}</td>
                <td>{{ props.item.studentCode }}</td>
                <td>{{ props.item.firstName }}</td>
                <td>{{ props.item.lastName }}</td>
                <td>{{ props.item.phone }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.classGroupName }}</td>
                <td>
                  <template>
                    <v-icon
                      small
                      class="mr-2"
                      @click.stop="_removeStudent(props.item)"
                      v-if="_isXAdmin(userProfile)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="mx-4">
          <v-spacer />
          <v-btn color="blue darken-1" text @click="showRevisionDialog = false">
            Цуцлаx
          </v-btn>
          <v-btn
            color="primary"
            class="text-capitalize font-weight-bold"
            @click="_closeRevisionDialog"
          >
            Xааx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="showStudentsDialog"
      max-width="800"
      v-if="lesson"
      persistent
    >
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold"
            >Суралцаж буй оюутнууд
            <span v-if="lesson.classGroups">
              ({{ lesson.classGroups.length }}x)</span
            ></span
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-tabs v-model="studentGroupTab">
            <v-tab v-for="(gc, gcindex) in lesson.classGroups" :key="gcindex">
              {{ gc.classGroupProgramName }}
              (
              <span v-if="lessonStudents && studentGroupTab == gcindex">{{
                lessonStudents.length
              }}</span>
              <span v-else>0</span> )
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="studentGroupTab">
            <v-tab-item
              v-for="(gc, gcindex) in lesson.classGroups"
              :key="gcindex"
            >
              <v-simple-table fixed-header height="600px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Нэр</th>
                      <th class="text-left">Оюутны код</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      @click="_printStudent(student)"
                      v-for="(student, sindex) in lessonStudents"
                      :key="'students-' + sindex"
                    >
                      <td>{{ student.index }}</td>
                      <td>{{ student.firstName }}</td>
                      <td>{{ student.lastName }}</td>
                      <td>{{ student.studentCode }}</td>
                      <td
                        :style="
                          student.state.code == 1 ? 'color:green' : 'color:red'
                        "
                      >
                        {{ student.state.name }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize font-weight-bold"
            @click="showStudentsDialog = false"
          >
            Xааx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Utilities
import { get } from "vuex-pathify";
import Vue from "vue";
import LessonContents from "./LessonContents";
import myfunction from "@/components/utils/myfunction.js";
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
export default {
  name: "TeacherLessonDetail",
  components: {},
  data: () => ({
    lessonStudents: null,
    studentGroupTab: null,
    showStudentsDialog: false,
    searchedStudentFound: false,
    searchedStudent: null,
    searchWord: null,
    headers: [
      {
        text: "No.",
        align: "start",
        sortable: true,
        value: "index",
      },
      {
        text: "Код",
        align: "start",
        sortable: true,
        value: "studentCode",
      },
      {
        text: "Нэр",
        align: "start",
        sortable: true,
        value: "firstName",
      },
      {
        text: "Овог",
        align: "start",
        sortable: true,
        value: "lastName",
      },
      {
        text: "Утас",
        align: "start",
        sortable: true,
        value: "phone",
      },
      {
        text: "Имэйл",
        align: "start",
        sortable: true,
        value: "email",
      },

      {
        text: "Мэргэжил/Анги",
        align: "start",
        sortable: true,
        value: "classGroupName",
      },
    ],

    showRevisionDialog: false,
    revisionStudents: null,
    lessonExams: null,
    assignments: null,
    selectedExam: null,
    showExamDialog: false,
    students: null,
    selectClassGroup: null,
    fullScreen: false,
    xClassGroups: null,
    xRooms: null,
    classGroups: null,
    selectedLessonClassGroup: null,
    lessonGroups: null,

    selectedClassGroupTobeRemoved: null,
    dialogDeleteClassGroup: false,
    addClassGroupDialog: false,
    selectedClassGroup: null,
    selectedClassGroupProgram: null,

    vselect_professions: null,
    editLessonInfo: null,
    editlessonInfoTab: null,
    openEditLessonInfoDialog: false,
    generalInfoTabs: null,
    stab: null,
    lesson: null,
    lessonStandard: null,
    curriculum: null,
    loading: false,
    lessonInfos: [
      { contents: [1, 2, 3], label: "Мэдлэг", kkey: "infos" },
      { contents: [1, 2, 3], label: "Чадвар", kkey: "results" },
      { contents: [1, 2, 3], label: "Xандлага", kkey: "attitudes" },
    ],
    contents: [
      {
        name: "Лекц",
        value: "creditLecture",
        childCollection: "lectures",
        datas: [],
        ctype: "lecture",
      },
      {
        name: "Семинар",
        value: "creditSeminar",
        childCollection: "seminars",
        datas: [],
        ctype: "seminar",
      },
      {
        name: "Лаборатори",
        value: "creditLabwork",
        childCollection: "labworks",
        datas: [],
        ctype: "labwork",
      },
      {
        name: "Дадлага",
        value: "creditHomework",
        childCollection: "homeworks",
        datas: [],
        ctype: "homework",
      },
    ],
    xeelj: null,
    timetables: null,
  }),
  watch: {
    studentGroupTab(val) {
      console.log(val);
      var xx = this.lesson.classGroups[val];
      this.lesson.ref.parent.parent
        .collection("students")
        .where(
          "xClassGroupProgramRef-" +
            this.userProfile.school.currentSemesterYears +
            "-1",
          "==",
          xx.classGroupProgramRef
        )
        .orderBy("firstName", "asc")
        .where("state.code", "==", 1)
        .onSnapshot((docs) => {
          this.lessonStudents = [];
          var counter = 0;
          docs.forEach((doc) => {
            counter++;
            let student = doc.data();
            student.id = doc.id;
            student.ref = doc.ref;
            student.index = counter;
            console.log(student);
            this.lessonStudents.push(student);
          });
        });
    },
    showStudentsDialog(val) {
      console.log(this.studentGroupTab);
    },
    searchWord(val) {
      if (val == null) {
        this.searchWord = val;
        this.studentScores = val;
        this.selectedStudent = val;
      }
    },
    stab(val) {},
    selectClassGroup(val) {
      console.log(val);
    },
  },
  components: { LessonContents },
  mixins: [myfunction],
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
 
  mounted() {
    this._setupp();
  },

  methods: {
    _printStudetestingnt(student) {
      console.log(student.ref.path);
    },
    _print() {
      console.log(this.lesson.ref.path);
    },
    _removeStudent(student) {
      student.studentRef
        .collection("revised-lessons")
        .doc(this.lesson.id)
        .delete()
        .then(() => {
          console.log("deleted lesson");
          this.lesson.ref
            .collection("revised-students")
            .doc(student.id)
            .delete()
            .then(() => {
              this.lesson.ref.update({
                numberOfrevisionStudents: fb.firestore.FieldValue.increment(-1),
              });
              console.log("deleted student ");
            });
        });
    },
    _addSearchedStudent(searchedStudent) {
      this.revisionStudents.push(searchedStudent);
      if (this.searchedStudent) {
        this.searchedStudent.school = null;
        this.searchedStudent.studentRef = this.searchedStudent.ref;
        this.lesson.ref
          .collection("revised-students")
          .doc(this.searchedStudent.id)
          .set(this.searchedStudent)
          .then(() => {
            var tmpLesson = {
              teacherFirstName: this.lesson.teacherFirstName
                ? this.lesson.teacherFirstName
                : null,
              teacherLastName: this.lesson.teacherLastName
                ? this.lesson.teacherLastName
                : null,
              teacherRef: this.lesson.teacherRef
                ? this.lesson.teacherRef
                : null,
              confirmed: this.lesson.confirmed ? this.lesson.confirmed : false,
              lessonStandard: this.lesson.lessonStandard
                ? this.lesson.lessonStandard
                : null,
              lessonStandard2: this.lesson.lessonStandard2
                ? this.lesson.lessonStandard2
                : null,
              lessonStandardRef: this.lesson.lessonStandardRef
                ? this.lesson.lessonStandardRef
                : null,
              calendarConfirmed: this.lesson.calendarConfirmed
                ? this.lesson.calendarConfirmed
                : false,
              lessonRef: this.lesson.ref,
            };

            this.lesson.ref
              .update({
                numberOfrevisionStudents: fb.firestore.FieldValue.increment(1),
              })
              .then(() => {
                this.searchedStudent.ref
                  .collection("revised-lessons")
                  .doc(this.lesson.id)
                  .set(tmpLesson)
                  .then(() => {
                    this.searchedStudent = null;
                    this.searchedStudentFound = false;
                  });
              });
          });
      }
    },
    _searchStudent() {
      if (this.searchWord && this.searchWord.length > 0) {
        fb.db
          .collection(fb.yyschool + "/students")
          .where("studentCode", "==", this.searchWord)
          .limit(1)
          .get()
          .then((docs) => {
            this.revisionStudents = [];

            if (!docs.empty) {
              let student = docs.docs[0].data();
              student.id = docs.docs[0].id;
              student.ref = docs.docs[0].ref;
              this.searchedStudent = student;

              this.searchedStudentFound = true;
            } else {
              this.searchedStudentFound = false;
            }
          });
      }
    },
    _closeRevisionDialog() {
      this.searchedStudentFound = false;
      this.showRevisionDialog = false;
    },
    _revisionStudents() {
      if (!this.revisionStudents) {
        this.lesson.ref.collection("revised-students").onSnapshot((docs) => {
          this.revisionStudents = [];
          var counter = 0;
          docs.forEach((doc) => {
            counter++;
            let student = doc.data();
            student.id = doc.id;
            student.ref = doc.ref;
            student.index = counter;
            this.revisionStudents.push(student);
          });
        });
      }
      this.searchedStudentFound = false;
      this.showRevisionDialog = true;
    },
    // _thisIsScore30(exam) {
    //   var lessonCode = null;
    //   var lessonName = null;
    //   var lessonId = null;

    //   if (this.lesson.lessonStandard2) {
    //     lessonCode = this.lesson.lessonStandard2.code;
    //     lessonName = this.lesson.lessonStandard2.name;
    //     lessonId = this.lesson.lessonStandard2.id;
    //   } else if (this.lesson.lessonStandard) {
    //     lessonCode = this.lesson.lessonStandard.code;
    //     lessonName = this.lesson.lessonStandard.name;
    //     lessonId = this.lesson.lessonStandard.id;
    //   }

    //   var participatedStudents = null;
    //   console.log(exam.examRef.path);
    //   exam.examRef
    //     .collection("results-simplified")
    //     .orderBy("totalScore", "desc")
    //     .onSnapshot(async (docs) => {
    //       participatedStudents = [];
    //       if (!docs.empty) {
    //         var counter = 1;
    //         var batch = fb.db.batch();
    //         docs.forEach((doc) => {
    //           let result = doc.data();
    //           result.ref = doc.ref;
    //           result.id = doc.id;
    //           result.index = counter;
    //           if (
    //             this.userProfile.school &&
    //             this.userProfile.school.currentSemester
    //           ) {
    //             var xx =
    //               this.userProfile.school.currentSemesterYears +
    //               "-" +
    //               this.userProfile.school.currentSemester;

    //             if (result.answerer.studentCode && lessonId) {
    //               var docId = result.answerer.studentCode + "-" + lessonId;
    //               console.log(result.answerer.studentCode, lessonId);
    //               // this.userProfile.school.ref
    //               //   .collection("_allStudentsScores")
    //               //   .doc(xx)
    //               //   .collection("yearScores")
    //               //   .doc(docId)
    //               //   .set(student, { merge: true })
    //               //   .then(() => {
    //               //     student["saved" + sindex] = true;
    //               //     console.log(docId);
    //               //   });
    //               //30,61
    //             }
    //           }

    //           participatedStudents.push(result);
    //         });
    //       }
    //     });
    // },
    _seeResults(exam) {
      var lessonStandardCode = null;
      var lessonName = null;
      var lessonStandardId = null;

      if (this.lesson.lessonStandard2) {
        lessonStandardCode = this.lesson.lessonStandard2.code;
        lessonName = this.lesson.lessonStandard2.name;
        // lessonId = this.lesson.id;
      } else if (this.lesson.lessonStandard) {
        lessonStandardCode = this.lesson.lessonStandard.code;
        lessonName = this.lesson.lessonStandard.name;
        // lessonId = this.lesson.id;
      }
      if (this.lesson.lessonStandardRef) {
        lessonStandardId = this.lesson.lessonStandardRef.id;
      }
      console.log(lessonStandardCode, lessonName, lessonStandardId);

      if (lessonStandardCode && lessonName && lessonStandardId) {
        this.$router.push({
          name: "StudentShowAssignmentAllResults",
          params: {
            sorilId: exam.examRef.path,
            maxNumber: exam.yyy,
            lessonStandardCode: lessonStandardCode,
            lessonName: lessonName,
            lessonStandardId: lessonStandardId,
            examRefPath: exam.ref.path,
          },
        });
      }
    },
    _deleteExam() {
      if (this.selectedExam) {
        this.selectedExam.ref.delete().then(() => {
          this.selectedExam = null;
          this.showExamDialog = false;
        });
      }
    },
    isGroupForExamSelected(exam, gc) {
      var found = false;
      if (exam.assignedClassGroupRefs) {
        for (var classGroupRef of exam.assignedClassGroupRefs)
          if (classGroupRef.path == gc.classGroupProgramRef.path) {
            found = true;
            break;
          }
      }
      if (found) {
        return true;
      } else {
        return false;
      }
    },
    _takeExam(exam, gc) {
      console.log(exam.ref.path);
      // console.log(exam.assignedClassGroupRefs)
      if (exam.assignedClassGroupRefs == undefined) {
        exam.assignedClassGroupRefs = [];
      }
      var counter = 0;
      var found = false;
      for (var xx of exam.assignedClassGroupRefs) {
        // if(xx.path == gc.)
        console.log(xx.path == gc.classGroupProgramRef.path);
        if (xx.path == gc.classGroupProgramRef.path) {
          found = true;
          break;
        }
        counter++;
      }
      console.log(found, counter);
      if (found == false)
        exam.assignedClassGroupRefs.push(gc.classGroupProgramRef);
      else exam.assignedClassGroupRefs.splice(counter, 1);

      exam.ref.set(
        {
          assignedClassGroupRefs: exam.assignedClassGroupRefs,
        },
        { merge: true }
      );
      console.log(gc);
    },
    _selectExam() {
      this.lesson.ref
        .collection("exams")
        .doc(this.selectedExam.id)
        .set(
          {
            examRef: this.selectedExam.ref,
            name: this.selectedExam.name,
            assignmentType: this.selectedExam.assignmentType,
            duration: this.selectedExam.duration,
            finalScore: this.selectedExam.finalScore,
            createdAt: new Date(),
          },
          { merge: true }
        )
        .then(() => {
          this.showExamDialog = false;
          this.selectedExam = null;
        });
    },
    _goToStudents() {
      this.$router.push({
        name: "StudentsPerGroup",
        params: { lesson: this.lesson, lessonexams: this.lessonExams },
      });
    },

    _finalScoreChanged(student) {
      console.log(student);
    },
    async _getStudents(classGroup) {
      return this.lesson["IWK4OtMCefPe8QCI9ISX-2"];
    },
    _calendarConfirmed(item) {
      item.ref.update({ calendarConfirmed: !item.calendarConfirmed });
    },
    _getTakeTime(contentTopics) {
      var counter = 0;
      for (var topic of contentTopics) {
        if (topic.taken) counter = counter + topic.tsag;
      }
      return counter;
    },
    _deleteClassGroupConfirm() {
      var list = [];
      var list2 = [];
      for (const xx of this.lesson.classGroups) {
        if (
          xx.classGroupRef.path !=
          this.selectedClassGroupTobeRemoved.classGroupRef.path
        ) {
          list.push(xx);
          list2.push(xx.classGroupProgramRef);
        }
      }
      this.lesson.ref
        .update({ classGroups: list, classGroupProgramRefs: list2 })
        .then(() => {
          this.dialogDeleteClassGroup = false;
        });
    },
    _removeClassGroupDialog(classGroup) {
      console.log(classGroup);
      this.dialogDeleteClassGroup = true;
      this.selectedClassGroupTobeRemoved = classGroup;
    },
    _openClassGroupDialog() {
      this.addClassGroupDialog = true;
      this.selectedClassGroup = {};
    },
    _saveClassGroupDialog() {
      if (this.selectedClassGroup) {
        console.log(this.selectedClassGroup);
        console.log(this.lesson.ref.path);
        console.log(this.selectedClassGroup);
        console.log(this.selectedClassGroupProgram);

        var dataa = {
          classGroups: fb.firestore.FieldValue.arrayUnion({
            classGroupName: this.selectedClassGroup.name,
            classGroupShortName: this.selectedClassGroup.name,
            // classGroupRef: this.selectedClassGroup.ref,
            classGroupRef: this.selectedClassGroup.ref
              ? this.selectedClassGroup.ref
              : null,
            classGroupProgramRef: this.selectedClassGroupProgram.ref
              ? this.selectedClassGroupProgram.ref
              : null,

            classGroupProgramName: this.selectedClassGroupProgram.name2
              ? this.selectedClassGroupProgram.name2
              : null,
            // classNumber: this.selectedClassGroup.classNumber,

            // departmentName: this.selectedDepartment.name,
            // departmentRef: this.selectedDepartment.ref,
          }),
          classGroupProgramRefs: fb.firestore.FieldValue.arrayUnion(
            this.selectedClassGroupProgram.ref
              ? this.selectedClassGroupProgram.ref
              : this.selectedClassGroupProgram
          ),
        };
        console.log(dataa.classGroupProgramRefs);
        this.lesson.ref.update(dataa).then(() => {
          this._closeClassGroupDialog();
        });
      }
    },
    _closeClassGroupDialog() {
      this.addClassGroupDialog = false;
      this.selectedClassGroup = null;
    },

    _closeEditInfo() {
      this.editLessonInfoIndex = -1;
      this.editLessonInfo = null;
      this.openEditLessonInfoDialog = false;
    },
    _saveLessonInfo() {
      this.lesson[this.lessonInfos[this.generalInfoTabs - 1].kkey][
        this.editLessonInfoIndex
      ] = this.editLessonInfo;

      this.lesson.ref.update(this.lesson).then(() => {
        this._closeEditInfo();
      });
    },

    _deleteLessonInfo() {
      var yes = confirm("Устгаxыг xүсэж байна уу?");
      if (yes) {
        var list = this.lesson[this.editlessonInfoTab.kkey];
        list.splice(this.editLessonInfoIndex, 1);
        var xx = {};
        xx[this.editlessonInfoTab.kkey] = list;
        this.lesson.ref.update(xx).then(() => {
          this._closeEditInfo();
        });
      }
    },
    _editContent(item, iindex, info, infoIndex) {
      this.openEditLessonInfoDialog = true;
      this.editLessonInfo = item;
      this.editlessonInfoTab = info;
      this.editLessonInfoIndex = iindex;
    },
    _getInfoList(info) {
      if (this.lesson != null && this.lesson[info.kkey])
        return this.lesson[info.kkey];
      else return [];
      // if(this.lesson[kkey]!=undefined&&this.lesson[kkey]!=null) return this.lesson[kkey]
      // else return  this.lesson[kkey] = []
    },
    _addInfo() {
      console.log(this.generalInfoTabs, this.lessonInfos);
      console.log(this.lessonInfos[this.generalInfoTabs - 1].kkey - 1);
      this.lesson[this.lessonInfos[this.generalInfoTabs - 1].kkey].push(
        "Теxтээ оруулна уу."
      );
      this.lesson.ref.update(this.lesson);
    },
    async _setupp() {
      this.loading = true;
      console.log(this.xpath);
      fb.db.doc(this.xpath).onSnapshot(async (doc) => {
        let lesson = doc.data();
        lesson.ref = doc.ref;
        lesson.id = doc.id;
        if (
          (lesson.classGroupProgramRefs == undefined &&
            lesson.classGroups &&
            lesson.classGroups.length > 0) ||
          (lesson.classGroupProgramRefs != undefined &&
            lesson.classGroupProgramRefs.length != lesson.classGroups.length)
        ) {
          var classGroupProgramRefsTMP = [];
          for (var xClassGroup of lesson.classGroups) {
            classGroupProgramRefsTMP.push(xClassGroup.classGroupProgramRef);
          }
          lesson.ref
            .update({ classGroupProgramRefs: classGroupProgramRefsTMP })
            .then(() => {
              console.log("transformed!!!");
            });
        }

        this.lesson = lesson;
        this.lesson.curriculumData = null;
        lesson.lessonStandard2 = null;
        if (lesson.lessonStandardRef) {
          lesson.lessonStandardRef.get().then((lessonStandard) => {
            if (lessonStandard.exists)
              lesson.lessonStandard2 = lessonStandard.data();
          });
        }
        this.lesson.ref
          .collection("lesson-groups")
          .orderBy("index", "asc")
          .where("deleted", "==", false)
          .onSnapshot((docs) => {
            this.lessonGroups = [];
            docs.forEach((doc) => {
              let gc = doc.data();
              gc.ref = doc.ref;
              gc.id = doc.id;
              gc.addedToTopic = false;
              this.lessonGroups.push(gc);
            });
          });
        this.lesson.ref.parent.parent
          .collection("xeelj")
          .orderBy("createdAt", "asc")
          .get()
          .then((docs) => {
            this.xeelj = [];
            docs.forEach((doc) => {
              let eelj = doc.data();
              eelj.ref = doc.ref;
              eelj.id = doc.id;
              this.xeelj.push(eelj);
            });
          });

        this.lesson.ref.parent.parent
          .collection(
            "/classGroups/" +
              this.userProfile.school.currentSemesterYears +
              "/classGroups"
          )
          .orderBy("name", "asc")
          .onSnapshot((querySnapshot) => {
            this.xClassGroups = [];
            querySnapshot.forEach((doc) => {
              let item = doc.data();
              item.id = doc.id;
              item.ref = doc.ref;
              item.programs = null;
              item.name2 = item.name + " (" + item.shortName + ")";
              item.ref.collection("programs").onSnapshot((docs) => {
                item.programs = [];
                item.students = [];
                docs.forEach((doc) => {
                  var program = doc.data();
                  program.ref = doc.ref;
                  program.id = doc.id;
                  program.name2 = program.shortName + "-" + program.classNumber;

                  this.lesson.ref.parent.parent
                    .collection("students")
                    .where(
                      "xClassGroupProgramRef-" +
                        this.userProfile.school.currentSemesterYears +
                        "-1",
                      "==",
                      program.ref
                    )
                    .get()
                    .then((docs) => {
                      this.lesson[program.id] = [];
                      this.lesson.students = [];
                      docs.forEach((doc) => {
                        let student = doc.data();
                        student.id = doc.id;
                        student.ref = doc.ref;
                        this.lesson.students.push(student);
                      });
                    });
                  item.programs.push(program);
                });
              });
              this.xClassGroups.push(item);
            });
          });
        this.lesson.ref.parent.parent
          .collection("xprofessions")
          .orderBy("name", "asc")
          .get()
          .then((docs) => {
            this.vselect_professions = [];
            docs.forEach((doc) => {
              let item = doc.data();
              item.id = doc.id;
              item.ref = doc.ref;
              item.name2 = "(" + item.shortName + ") " + item.name;
              this.vselect_professions.push(item);
            });
          });
        this.lesson.ref.parent.parent
          .collection("xrooms")
          .orderBy("name", "asc")
          .get()
          .then((docs) => {
            this.xRooms = [];
            docs.forEach((doc) => {
              let item = doc.data();
              item.id = doc.id;
              item.ref = doc.ref;
              this.xRooms.push(item);
            });
          });
        var calQuery;
        if (this.lesson.calendarConfirmed) {
          calQuery = this.lesson.ref.collection(
            "calendars-" + this.userProfile.school.currentYear.toString()
          );
        } else {
          calQuery = this.lesson.ref.collection("calendars-2022");
        }
        calQuery.onSnapshot((docs) => {
          this.timetables = [];
          var batch = fb.db.batch();
          docs.forEach((doc) => {
            let tt = doc.data();
            tt.ref = doc.ref;
            tt.id = doc.id;
            if (!this.lesson._calendarRestored) {
              batch.set(
                this.lesson.ref
                  .collection(
                    "calendars-" +
                      this.userProfile.school.currentYear.toString()
                  )
                  .doc(tt.id),
                tt,
                { merge: true }
              );
            }
            this.timetables.push(tt);
          });
          batch.commit().then(() => {
            this.lesson.ref.update({ _calendarRestored: true });
          });
        });

        var lessonStandard = await this.lesson.lessonStandardRef.get();
        this.lessonStandard = lessonStandard.data();
        if (this.lesson.curriculumRef) {
          var curriculum = await this.lesson.curriculumRef.get();
          this.curriculum = curriculum.data();
        }
        for (var info of this.lessonInfos) {
          if (!lesson[info.kkey]) {
            lesson[info.kkey] = [];
          }
        }

        for (const xcontent of this.contents) {
          this.lesson.ref
            .collection(xcontent.childCollection)
            .orderBy("createdAt", "asc")
            .onSnapshot((querySnapshot) => {
              xcontent.datas = [];
              querySnapshot.forEach((doc) => {
                let content = doc.data();
                content.ref = doc.ref;
                content.id = doc.id;
                xcontent.datas.push(content);
              });
            });
        }

        this.lesson.ref.collection("exams").onSnapshot((docs) => {
          this.lessonExams = [];
          docs.forEach((doc) => {
            let assign = doc.data();
            assign.id = doc.id;
            assign.ref = doc.ref;
            this.lessonExams.push(assign);
          });
        });
      });

      this.userProfile.ref
        .collection("teacher-asssignments")
        .where("deleted", "==", false)
        .onSnapshot((docs) => {
          this.assignments = [];
          docs.forEach((doc) => {
            let assign = doc.data();
            assign.id = doc.id;
            assign.ref = doc.ref;
            this.assignments.push(assign);
          });
        });
    },
  },
  props: {
    xpath: {
      type: String,
      required: true,
    },
  },
};
</script>
<style>
.v-list--three-line .v-list-item,
.v-list-item--three-line {
  min-height: 44px;
}
.groupbox {
  cursor: pointer;
}
.groupbox:hover {
  border-style: dashed;
}

.scoreTables td,
.scoreTables th {
  border: 1px solid #dddddd;
  text-align: left;
  height: 25px !important;
}
</style>

